// 全部的路由路径
export const ROUTER_ALL = [
  '/',
  '/test',
  '/privacy',
  '/terms',
  '/home',
  '/pay-result',
  '/order-query',
  '/notice',
  '/message',
  '/about',
  '/coupon',
  '/feedback',
  '/feedback-edit',
  '/order-detail',
  '/order',
  '/about',
  '/facebook',
  '/account',
  '/contact',
  '/feedback-record',
  '/messageBoard',
  '/search-order',
  '/bing',
  '/prize-record',
  '/luckyDraw',
  '/feedback-answer',
  '/account-appeal',
  '/password-edit',
  '/password-bind',
  '/email',
  '/expensesRecord',
  '/rechargeResult',
  '/myWallet',
  '/membersRule',
  '/membersReward',
  '/membersPrivilege',
  '/loginCode',
  '/cookiePolicy',
  '/fission',
  '/fission-exchange',
  '/fission-rules',
  '/fission-record',
  '/share/:hashcode',
  '/appSidebar',
  '/ranking',
  '/ranking-rules',
  '/getlucky',
  '/getlucky-result',
  '/getlucky-rule',
  '/getlucky-record-winning',
  '/getlucky-record-exchange',
  '/kcard-redemption',
  '/compen-query',
  '/eUnsub',
  '/bind-mobile-phone',
  '/bind-successful',
  '/modify-phone',
  '/history-coupon',
  '/free-fire',
]

const PREFIX = {
  '/lm': '/lordsmobile',
  '/ys': '/genshin',
  '/ik': '/infinity-kingdom',
  '/ml': '/mobile-legends',
  '/ss': '/state-of-survival',
  '/iw': '/infinity-war',
  '/ps': '/puzzles-survival',
  '/sl': '/soul-land3d',
  '/rx': '/roblox',
  '/cme': '/call-me-emperor',
  '/sn': '/shining-nikki',
  '/goc': '/guardians-of-cloudia',
  '/gos': '/game-of-sultans',
  '/gok': '/game-of-khans',
  '/tv': '/turbo-vpn',
  '/vpm': '/vpn-proxy-master',
  '/kl': '/kungfu-legend',
  '/sm': '/star-maker',
  '/ffd': '/freefire-diamonds',
  '/ffmd': '/freefiremax-diamonds',
  '/hd': '/higgs-domino',
  '/ab': '/arena-breakout',
}

const CPREFIX = Object.assign({}, PREFIX)

// 嗨 默认的详情配置需要用、路径：src/plugins/game-config.js
const FPREFIX = ((paths) => {
  let data = {}

  for (let key in paths) {
    data[key.slice(1)] = paths[key].slice(1)
  }
  return data
})(CPREFIX)

export { CPREFIX, FPREFIX }
